// extracted by mini-css-extract-plugin
export default {"giftBtn":"Gift_giftBtn__EAfxg","bounce":"Gift_bounce__E2ieH","giftImg":"Gift_giftImg__n5Zg1"};